import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useReduxSelector } from "../../../hooks/useGetAdherent";
import { getListeAdhesions } from "../../../redux/AdherentRedux";
import {
  getListeCompteFidelite,
  setListeCompteFidelite,
} from "../../../redux/FideliteRedux";
import Api, { IApi } from "../../../services/Api";
import { getApiEndpoint } from "../../../services/Config";
import { ErrorApi } from "../../../types";

export const useCompteFidelite = () => {
  const listeAdhesions = useReduxSelector((state) => getListeAdhesions(state));
  const dispatch = useDispatch();
  const listeCompteFidelite = useReduxSelector((state) =>
    getListeCompteFidelite(state)
  );
  const [fetchingCompteFidelite, setFetchingCompteFidelite] = useState<boolean>(
    false
  );
  const [errorCompteFidelite, setErrorCompteFidelite] = useState<ErrorApi>();
  useEffect(() => {
    if (listeAdhesions && !listeCompteFidelite) {
      const api: IApi = Api.create(getApiEndpoint() || "http://localhost:8090"); // récupération de l'url de l'api (intégration, recette, production... )
      listeAdhesions.forEach((adh) => {
        setFetchingCompteFidelite(true);
        adh &&
          api["getFideliteByNumeroAdhesion"](adh.numeroAdhesion)
            .then((response) => {
              dispatch(setListeCompteFidelite(response));
              setFetchingCompteFidelite(false);
            })
            .catch(function (error) {
              setFetchingCompteFidelite(false);
              setErrorCompteFidelite(error);
            });
      });
    }
  }, [listeAdhesions, listeCompteFidelite]);

  return {
    fetchingCompteFidelite,
    errorCompteFidelite,
    listeCompteFidelite,
  };
};
